module.exports = __webpack_public_path__ + "static/Rippling-6c0ceab66e33014a74dd0006e99c4805.jpg";